import React from "react";
import { FaTimes } from "react-icons/fa";

const CategoryDistributionDrawer = ({ isOpen, onClose, title, data }) => {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity"
        onClick={onClose}
      ></div>

      <div
        className={`fixed top-0 right-0 h-full w-[90%] max-w-[400px] bg-[#1a1a1a] shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="h-full flex flex-col">
          {/* Header */}
          <div className="p-6 border-b border-gray-800 flex justify-between items-center bg-[#242424]">
            <div>
              <h2 className="text-xl font-bold text-white">{title}</h2>
              <p className="text-sm text-gray-400 mt-1">Grouped by Category</p>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white transition-colors p-2 rounded-full hover:bg-gray-700"
            >
              <FaTimes size={20} />
            </button>
          </div>

          {/* Body */}
          <div className="flex-1 overflow-y-auto p-6">
            {!data || data.length === 0 ? (
              <div className="text-gray-500 text-center mt-10">No items found.</div>
            ) : (
              <div className="space-y-3">
                {data.map((item, index) => (
                  <div key={index} className="flex justify-between items-center bg-[#2a2a2a] p-4 rounded-xl border border-gray-700">
                    <span className="text-gray-200 font-medium">{item.categoryName}</span>
                    <span className="bg-red-500/20 text-red-400 px-3 py-1 rounded-full text-sm font-bold border border-red-500/30">
                      {item.count}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryDistributionDrawer;
